import { getGlobalEventMergeId } from '../../_common/client/tracking';
import { TrackingFeatures } from './event-data-types';

export class VariationDataEnhancer {
    private cachedVariationData: TrackingFeatures | undefined;
    private lastKnownEventMergeId: string | undefined;

    public enhance<T>(trackingData: T): T & { features?: TrackingFeatures } {
        // The event merge id changes on variation change, so if it changes we need to fetch the variation data again
        if (this.cachedVariationData && this.lastKnownEventMergeId === getGlobalEventMergeId()) {
            return { ...trackingData, features: this.cachedVariationData };
        }
        const variationData = VariationDataEnhancer.extractVariationDataFromHTML();
        this.cachedVariationData = variationData;
        this.lastKnownEventMergeId = getGlobalEventMergeId();
        return { ...trackingData, features: variationData };
    }

    private static extractVariationDataFromHTML(): TrackingFeatures | undefined {
        const variationTrackingJson = document.querySelector('#js_pdp_variationTrackingData')?.textContent;
        if (!variationTrackingJson) return;
        const parsedVariationTrackingJson: TrackingFeatures = JSON.parse(variationTrackingJson);
        const additionalPageImpressionFeatures = parsedVariationTrackingJson
            .filter(feature => feature.status === 'visible')
            .map(feature => {
                if (feature.name === 'Business-Dimension' || feature.name === 'Variation') {
                    // Business dimensions and variation have labels that are not needed on page impression
                    feature.labels = {};
                }
                return feature;
            });
        return additionalPageImpressionFeatures;
    }
}
